import axios from "../axios/axios";

// ITAM-2887: logout-time side effects only.
//
// This branch's axios instance has no 401/403 logout interceptor, so the
// shared instance is safe here: a rejected pause simply rejects. Its REQUEST
// interceptor reads the token from localStorage when the request is sent,
// which is why the caller must AWAIT these tasks before dispatching
// `auth/logout` (which clears localStorage); the bound below keeps that wait
// short.

export const pauseAdvisorOnLogout = (userId: number, signal: AbortSignal) =>
  axios.put(
    `/advisor_profile/user_id/${userId}/availability?available=false`,
    null,
    { signal },
  );

export const LOGOUT_SIDE_EFFECT_TIMEOUT_MS = 3000;

/**
 * One controller, one timer, shared by every task.
 *
 * `Promise.allSettled` is not a timeout (it settles only when every input
 * settles), so what makes the timer effective is the abort: axios honours
 * `signal`, and an aborted request REJECTS with `CanceledError`, which
 * settles the input promise. The function never rejects.
 */
export async function runBoundedLogoutSideEffects(
  tasks: Array<(signal: AbortSignal) => Promise<unknown>>,
): Promise<void> {
  const controller = new AbortController();
  const timer = setTimeout(
    () => controller.abort(),
    LOGOUT_SIDE_EFFECT_TIMEOUT_MS,
  );
  try {
    await Promise.allSettled(tasks.map((task) => task(controller.signal)));
  } finally {
    clearTimeout(timer);
  }
}
